import { Helpers } from '../../helpers';
import { IPostStimMethod } from '../../interfaces/ipost-stim-method';
import { CompletionsRentalUnitCost } from '../completions-rental-unit-cost';

export class PostStimMethodBase {
  PostStimMethodId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  CompletionsRentalUnitCosts_PostStimMethod?: Array<CompletionsRentalUnitCost> | null;

  constructor(item?: IPostStimMethod) {
    if (item) {

      this.PostStimMethodId = item.PostStimMethodId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.CompletionsRentalUnitCosts_PostStimMethod = Helpers.createClassArray(CompletionsRentalUnitCost, item.CompletionsRentalUnitCosts_PostStimMethod);
    }
  }
}